<div class="dialog">

    <div class="dialog-header">
        <h3>{{ 'SALES_DOCUMENT|Statusy oferty' | translate }}</h3>
        <button 
            iccIconButton 
            (click)="close()"
            appearance="flat"
        >
            <icc-icon name="close"></icc-icon>
        </button>
    </div>
    <div class="dialog-body">
        <p class="status-header" [innerHTML]="'SALES_DOCUMENT|Możliwe statusy dokumentu typu {documentType}, oraz powiązanie statusów z flagami dokumentu.' | translate: {documentType: ('<strong>' + documentTypeName + '</strong>')}">
        </p>
        <div>
            <table>
                <thead>
                    <tr>
                        <th translate class="flag-header">SALES_DOCUMENT|Flagi:</th>
                        <th rowspan="2" class="document-flag" *ngFor="let flag of documentFlags"><span>{{ flag.name }}</span></th>
                    </tr>
                    <tr>
                        <th translate class="status-header">SALES_DOCUMENT|Status:</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let status of documentStatuses">
                        <td class="document-status"><icc-document-status [status]="status"></icc-document-status></td>
                        <td *ngFor="let flag of documentFlags">
                            <icc-static-flag
                                [checked]="status.flagCombination[0][flag.code] == '1'"
                                [indeterminate]="status.flagCombination[0][flag.code] != '1' && status.flagCombination[0][flag.code] != '0'"
                            ></icc-static-flag>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="dialog-footer">
        <div class="flex-horizontal width-100">
            <button iccButton (click)="close()" class="right">{{ 'INTERFACE|OK' | translate}}</button>
        </div>
    </div>

</div>
<div 
    class="curtain"
    (click)="close()"
></div>